import { combineReducers } from 'redux';
import { medicationReducer as medications } from './medication-reducer';
import { suggestionsReducer as medicationAutosuggest } from './suggestion-reducer';

export const reducer = combineReducers({ medications, medicationAutosuggest });
